/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingRoleUpdateApprovalRequestDto
 */
export interface PendingRoleUpdateApprovalRequestDto {
    /**
     * User Id
     * @type {string}
     * @memberof PendingRoleUpdateApprovalRequestDto
     */
    approvedById: string;
    /**
     * User Id
     * @type {string}
     * @memberof PendingRoleUpdateApprovalRequestDto
     */
    userId: string;
    /**
     * User's role in the org
     * @type {string}
     * @memberof PendingRoleUpdateApprovalRequestDto
     */
    role: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof PendingRoleUpdateApprovalRequestDto
     */
    orgId: string;
    /**
     * oor or ecr type in case it is role of that types
     * @type {string}
     * @memberof PendingRoleUpdateApprovalRequestDto
     */
    jobTitleType?: string;
}

/**
 * Check if a given object implements the PendingRoleUpdateApprovalRequestDto interface.
 */
export function instanceOfPendingRoleUpdateApprovalRequestDto(value: object): boolean {
    if (!('approvedById' in value)) return false;
    if (!('userId' in value)) return false;
    if (!('role' in value)) return false;
    if (!('orgId' in value)) return false;
    return true;
}

export function PendingRoleUpdateApprovalRequestDtoFromJSON(json: any): PendingRoleUpdateApprovalRequestDto {
    return PendingRoleUpdateApprovalRequestDtoFromJSONTyped(json, false);
}

export function PendingRoleUpdateApprovalRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingRoleUpdateApprovalRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'approvedById': json['approvedById'],
        'userId': json['userId'],
        'role': json['role'],
        'orgId': json['orgId'],
        'jobTitleType': json['jobTitleType'] == null ? undefined : json['jobTitleType'],
    };
}

export function PendingRoleUpdateApprovalRequestDtoToJSON(value?: PendingRoleUpdateApprovalRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'approvedById': value['approvedById'],
        'userId': value['userId'],
        'role': value['role'],
        'orgId': value['orgId'],
        'jobTitleType': value['jobTitleType'],
    };
}

